/**
 * region for libraries*/
import React, { Component } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { CircularProgress } from '@material-ui/core';
/**
 * region for componets*/
import { InlineTextEditor } from '../../../../components/common/InlineTextEditor';
import { ConfirmationModal } from '../../../../components/common/ConfirmationModal';
import { WizardAddKeywordModal } from '../../../../components/common/AddKeywordModal/WizardAddKeywordModal';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import {commonFunction} from '../../../../helpers/commonFunction';

/**
 * region for constans*/
import Constants from '../../../../constants/Constants'
import typing from "../../../../helpers/typing";

export class ProductRow extends Component {
    static displayName = ProductRow.name;

    constructor(props) {
        super(props);
        this.state = {
            showDeleteModal: false,
            showAddKeywordModal: false,
            anchorEl : null,
            suggestions:[],
            loanding: false,
            row: props.row,
        };

        this.productTableName = 'WEB_PRODUCTS';
        this.productUrl = Constants.ROUTE_API_CONTENT_WEBPRODUCTS;
        this.backofficeUrlBase = this.props.backofficeUrlBase;
    }
    componentDidMount(){
        this.setState({ row: this.props.row });
    }

    handleDeleteClick() {
        this.setState({ showDeleteModal: true });
    }

    handleOnCloseModal() {
        this.setState({ showDeleteModal: false });
    }

    handleOnCloseAddKeywordModal() {
        this.setState({ showAddKeywordModal: false });
    }

    handleOnClickConfirmDelete() {

        const self = this;

        ajax.delete(this.productUrl,
            {
                requestData: {
                    idContent: self.props.row.IDCONTENT,
                    idContentType: self.props.row.idContentType
                },
                success: function () {
                    if (self.props.onProductDeleted) {
                        self.props.onProductDeleted(self.props.row);
                    }
                }
            });

    }

    handleShowAddKeyword() {
        this.setState({showAddKeywordModal: true });
    }

    handleClick(row,event) {
        const self = this;
        self.setState({ anchorEl : event.currentTarget, loanding: true });

        let requestdata = {
            IdSite: row.IDSITE,
            IdContent:row.IDCONTENT,
            IdProductType: row.ID_PROD_TYPE,
            Text:row.PRODUCTTITLE
        };

        ajax.post(Constants.ROUTE_API_CONTENT_WEBPRODUCTS_GET_SUGGESTER,
        {
            requestData: requestdata,
            success: function (response) {
                let suggestions = []
                if(!typing.isEmpty(response.data)){
                    response.data.forEach(function (item) {
                        let suggestion = { suggestion: item.Suggestion};
                        suggestions.push(suggestion)
                    })
                }
                self.setState({suggestions: suggestions,loanding: false});
            }
        });
    };

    handleClose(option) {
        this.setState({ anchorEl: null });
    };

    handleClickSelectSugester(sugester,row,event){
        let self=this;
        //console.log(self.props.idContentType)
        row.PRODUCTTITLE=sugester.suggestion
        let requestData = {
            idContent: row.IDCONTENT,
            idContentType: self.props.idContentType,
            data: [
                {
                    key: "PRODUCTTITLE",
                    value: sugester.suggestion
                }
            ]
        };

        ajax.put(Constants.ROUTE_API_CONTENT_WEBPRODUCTS,
            {
                requestData: requestData,
                success: function () {
                    self.setState({ anchorEl: null, row: row });
                }
            });      
    }

    render() {

        const self = this;
        const { anchorEl } = this.state;
        const site = commonFunction.getSiteAcronym(this.props.row.IDSITE);
        const linkContent = `${this.backofficeUrlBase}/Extended_Product.asp?idproduct=${this.props.row.IDCONTENT}`;
        const linkCompany = `${this.backofficeUrlBase}/File_Contactmoment.asp?code=${this.props.row.IDCLIENT}`;

        return (
            <tr>
                <th scope="row">

                    <div className="d-flex-inline-center">
                        <a href="#/" onClick={this.handleDeleteClick.bind(self)}><i className="far fa-times-circle mr-1"></i></a>
                        <a target="_blank" rel="noopener noreferrer" href={linkContent}> {this.props.row.IDCONTENT}</a>

                        {this.state.showDeleteModal && <ConfirmationModal                        
                            text="Are you sure you want to delete this content?"
                            onAccept={this.handleOnClickConfirmDelete.bind(self)}
                            onClose={this.handleOnCloseModal.bind(self)}
                            className="modal-sm"
                        />}
                    </div>
                        
                </th>
                <td>
                    <InlineTextEditor
                        tableName={this.productTableName}
                        row={this.state.row}
                        wrapperClass="large full-width"
                        className="form-control form-control-lg"
                        fieldName="PRODUCTTITLE"
                        url={this.productUrl}
                        idContent={this.state.row.IDCONTENT}
                        idContentType={this.props.idContentType} />                   
                </td>
                <td>
                    <div className="d-flex-inline-center">
                        {
                            this.state.row.IDSITE > 0 && <a href="#/" onClick={this.handleClick.bind(this, this.state.row)}><i className="fas fa-list mr-1"></i></a>
                        }
                        <a href="#/" onClick={this.handleShowAddKeyword.bind(self)}><i className="fas fa-plus-circle"></i></a>
                    </div>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose.bind(this)}>
                        {
                            this.state.loanding && <span className="pl-1 pr-1 pt-0 pb-0"><CircularProgress size={20} /></span>
                        }
                        {
                          this.state.suggestions.length > 0 && this.state.suggestions.map((option, index) => {
                                return (
                                    <MenuItem key={index} onClick={this.handleClickSelectSugester.bind(this,option,this.props.row)}>
                                        {option.suggestion}
                                    </MenuItem>
                                )
                            })
                        }
                        {
                         this.state.suggestions.length < 0 && <span className="pl-1 pr-1 pt-0 pb-0">no suggestions</span>
                        }
                    </Menu>
                </td>
                <td>
                    <InlineTextEditor
                        tableName={this.productTableName}
                        row={this.props.row}
                        className="form-control form-control-lg"
                        fieldName="BRAND_NAME"
                        url={this.productUrl}
                        idContent={this.props.row.IDCONTENT}
                        idContentType={this.props.idContentType} />
                </td>
                <td>
                    <InlineTextEditor
                        tableName={this.productTableName}
                        row={this.props.row}
                        className="form-control form-control-lg"
                        fieldName="MODEL_NO"
                        url={this.productUrl}
                        idContent={this.props.row.IDCONTENT}
                        idContentType={this.props.idContentType} />
                </td>
                <td>{this.props.row.KEYWORDS_IN_TITLE && this.props.row.KEYWORDS_IN_TITLE.substring(2)}</td>
                <td className="text-center">{this.props.row.ONLINE && <i className="fas fa-check"></i>}</td>
                <td><a target="_blank" rel="noopener noreferrer" href={linkCompany}>{this.props.row.IDCLIENT}</a></td>
                <td><a target="_blank" rel="noopener noreferrer" href={linkCompany}>{this.props.row.COMPANY}</a></td>
                <td>
                    <div className="d-flex-inline-center">
                    <span className={`badge badge-alt badge-${site}`}>{site}</span>
                        {this.props.row.ISCLIENT && <i className="fas fa-award font-size-lg ml-2"></i>}
                    </div>
                </td>
                {
                    this.state.showAddKeywordModal &&
                    <WizardAddKeywordModal
                        keywordText={this.props.row.PRODUCTTITLE.toLowerCase()}
                        titleHeader={"Create Keyword"}
                        currentStep={0}
                        keywordsSelect={null}
                        onClose={this.handleOnCloseAddKeywordModal.bind(self)}
                        className="modal-lg add-keyword"
                        saveInModalView={true} />
                }
            </tr>
        );
    }

}